/**
 * Arkius Certification Kickstarter API
 * Arkius PBC API v5.2026.1012.0845
 *
 * The version of the OpenAPI document: v1
 * Contact: info@arkius.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Registration { 
    Password: string;
    Email?: string | null;
    FirstName?: string | null;
    LastName?: string | null;
    Username?: string | null;
    ZipCode?: string | null;
    InviteCode?: string | null;
    CountryId?: number | null;
    Birthdate?: string | null;
    Token?: string | null;
}

